import React, { FC } from "react";
import { Card, CardContent, CardHeader, Container, Divider, Grid, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";
import store from "./store";
import { observer } from "mobx-react";
import LookUp from "components/LookUp";
import CustomTextField from "components/TextField";
import DateTimeField from "components/DateTimeField";

type IncomingDocumentTableProps = {
  children?: React.ReactNode;
  isPopup?: boolean;
};

const IncomingDocumentAddEditBaseView: FC<IncomingDocumentTableProps> = observer((props) => {
  const { t } = useTranslation();
  const translate = t;

  return (
    <Container maxWidth='xl' sx={{ mt: 3 }}>
      <Grid container spacing={3}>
        <Grid item md={props.isPopup ? 12 : 6}>
          <form data-testid="incomingDocumentForm" id="incomingDocumentForm" autoComplete='off'>
            <Card component={Paper} elevation={5}>
              <CardHeader title={
                <span id="incoming_document_TitleName">
                  {translate('label:incomingDocumentAddEditView.entityTitle')}
                </span>
              } />
              <Divider />
              <CardContent>
                <Grid container spacing={3}>

                  <Grid item md={12} xs={12}>
                    <LookUp
                      value={store.document_type_id}
                      onChange={(event) => store.handleChange(event)}
                      name="document_type_id"
                      data={store.document_types}
                      id="id_f_incoming_document_document_type_id"
                      label={translate("label:incomingDocumentAddEditView.document_type_id")}
                      helperText={store.errors.document_type_id}
                      error={!!store.errors.document_type_id}
                      disabled={true}
                    />
                  </Grid>

                  <Grid item md={12} xs={12}>
                    <CustomTextField
                      value={store.name}
                      onChange={(event) => store.handleChange(event)}
                      name="name"
                      data-testid="id_f_incoming_document_name"
                      id='id_f_incoming_document_name'
                      label={translate('label:incomingDocumentAddEditView.name')}
                      helperText={store.errors.name}
                      error={!!store.errors.name}
                      disabled={true}

                    />
                  </Grid>

                  <Grid item md={12} xs={12}>
                    <CustomTextField
                      value={store.file_name}
                      onChange={(event) => store.handleChange(event)}
                      name="file_name"
                      data-testid="id_f_incoming_document_file_name"
                      id='id_f_incoming_document_file_name'
                      label={translate('label:incomingDocumentAddEditView.file_name')}
                      helperText={store.errors.file_name}
                      error={!!store.errors.file_name}
                      disabled={true}

                    />
                  </Grid>

                  <Grid item md={12} xs={12}>
                    <CustomTextField
                      value={store.bga_document_number}
                      onChange={(event) => store.handleChange(event)}
                      name="bga_document_number"
                      data-testid="id_f_incoming_document_bga_document_number"
                      id='id_f_incoming_document_bga_document_number'
                      label={translate('label:incomingDocumentAddEditView.bga_document_number')}
                      helperText={store.errors.bga_document_number}
                      error={!!store.errors.bga_document_number}
                      disabled={true}

                    />
                  </Grid>

                  <Grid item md={12} xs={12}>
                    <DateTimeField
                      value={store.bga_document_date}
                      onChange={(event) => store.handleChange(event)}
                      name="bga_document_date"
                      id='id_f_incoming_document_bga_document_date'
                      label={translate('label:incomingDocumentAddEditView.bga_document_date')}
                      helperText={store.errors.bga_document_date}
                      error={!!store.errors.bga_document_date}
                      disabled={true}

                    />
                  </Grid>

                  <Grid item md={12} xs={12}>
                    <CustomTextField
                      value={store.received_from}
                      onChange={(event) => store.handleChange(event)}
                      name="received_from"
                      type="number"
                      data-testid="id_f_incoming_document_received_from"
                      id='id_f_incoming_document_received_from'
                      label={translate('label:incomingDocumentAddEditView.received_from')}
                      helperText={store.errors.received_from}
                      error={!!store.errors.received_from}
                      disabled={true}

                    />
                  </Grid>

                  <Grid item md={12} xs={12}>
                    <DateTimeField
                      value={store.received_at}
                      onChange={(event) => store.handleChange(event)}
                      name="received_at"
                      id='id_f_incoming_document_received_at'
                      label={translate('label:incomingDocumentAddEditView.received_at')}
                      helperText={store.errors.received_at}
                      error={!!store.errors.received_at}
                      disabled={true}

                    />
                  </Grid>

                </Grid>
              </CardContent>
            </Card>
          </form>
        </Grid>
        {props.children}
      </Grid>
    </Container>
  );
})

export default IncomingDocumentAddEditBaseView;